import { type FunctionComponent } from "react";

import ArticleDetail from "./article-detail.svg";
import { Right } from "./styles";

type Props = {
  className?: string;
};

export const PlusNewsAgendaRightPlaceholder: FunctionComponent<Props> = () => (
  <Right>
    <ArticleDetail />
  </Right>
);

PlusNewsAgendaRightPlaceholder.displayName = "PlusNewsAgendaRightPlaceholder";
